import { RestClient } from '../utils/rest-client';
import { configService } from './config.service';
import { ServiceWrapper } from '../utils/service-wrapper';
// import { ApiError } from '../utils/errors';
const restClient = RestClient(configService.restConfig);
async function getQuizzes({ status, }) {
    return ServiceWrapper.executeWithCommonHandling(async () => {
        const apiResponse = await restClient.get({
            openapiPath: '/quizzes',
            queryParams: {
                status,
            },
        });
        return apiResponse.body.Data.Quizzes;
    }, {
        resourceName: 'quizzes',
        operation: 'fetch',
    });
}
async function createQuiz(quiz) {
    return ServiceWrapper.executeWithCommonHandling(async () => {
        const apiResponse = await restClient.post({
            openapiPath: '/quizzes',
            requestBody: {
                Data: quiz,
            },
        });
        return apiResponse.body.Data.Quiz;
    }, {
        resourceName: 'quiz',
        operation: 'create',
    });
}
async function getQuizDetails(quizId) {
    const apiResponse = await restClient.get({
        openapiPath: '/quizzes/{QuizId}',
        pathParams: {
            QuizId: quizId,
        },
    });
    return apiResponse.body.Data.Quiz;
}
async function updateQuiz(quizId, data) {
    const apiResponse = await restClient.put({
        openapiPath: '/quizzes/{QuizId}',
        pathParams: {
            QuizId: quizId,
        },
        requestBody: {
            Data: data,
        },
    });
    return apiResponse.body.Data.Quiz;
}
async function deleteQuiz(quizId) {
    return ServiceWrapper.executeWithCommonHandling(async () => {
        await restClient.delete({
            openapiPath: '/quizzes/{QuizId}',
            pathParams: {
                QuizId: quizId,
            },
        });
        return { quizId };
    }, {
        resourceName: 'quiz',
        operation: 'delete',
    });
}
async function updateQuizStatus(quizId, status) {
    const apiResponse = await restClient.put({
        openapiPath: '/quizzes/{QuizId}/status',
        pathParams: {
            QuizId: quizId,
        },
        requestBody: {
            Data: {
                status,
            },
        },
    });
    return { ...apiResponse.body.Data.Quiz, quizId };
}
async function addQuestion(quizId, question) {
    const apiResponse = await restClient.post({
        openapiPath: '/quizzes/{QuizId}/questions',
        pathParams: {
            QuizId: quizId,
        },
        requestBody: {
            Data: question,
        },
    });
    return { quizId, question: apiResponse.body.Data.Question };
}
async function updateQuestion(quizId, questionId, question) {
    const apiResponse = await restClient.put({
        openapiPath: '/quizzes/{QuizId}/questions/{QuestionId}',
        pathParams: {
            QuizId: quizId,
            QuestionId: questionId,
        },
        requestBody: {
            Data: question,
        },
    });
    return { quizId, question: { ...apiResponse.body.Data.Question } };
}
async function removeQuestion(quizId, questionId) {
    await restClient.delete({
        openapiPath: '/quizzes/{QuizId}/questions/{QuestionId}',
        pathParams: {
            QuizId: quizId,
            QuestionId: questionId,
        },
    });
    return { quizId, questionId };
}
async function getSubmissions(quizId) {
    const apiResponse = await restClient.get({
        openapiPath: '/quizzes/{QuizId}/submissions',
        pathParams: {
            QuizId: quizId,
        },
    });
    return apiResponse.body.Data.Submissions;
}
const quizService = {
    getQuizzes,
    createQuiz,
    getQuizDetails,
    updateQuiz,
    deleteQuiz,
    updateQuizStatus,
    addQuestion,
    updateQuestion,
    removeQuestion,
    getSubmissions,
};
export { quizService };
